// extracted by mini-css-extract-plugin
module.exports = {"search":"styles_search__3zIVj","tokenList":"styles_tokenList__3Iw7s","token":"styles_token__2zUpO"};